export default __webpack_public_path__ + "static/media/payroll-feature-accuracy.7482a8ef.svg";